import React from 'react';
import {
  POS_ORDER_STATUS_LABELS,
  type OnlineOrderStatus,
} from '@src/types/onlineOrder';

const STATUS_BADGE_CLASS: Record<OnlineOrderStatus, string> = {
  placed: 'online-order-badge--placed',
  accepted: 'online-order-badge--accepted',
  preparing: 'online-order-badge--preparing',
  ready: 'online-order-badge--waiting-for-rider',
  waiting_for_rider: 'online-order-badge--waiting-for-rider',
  on_the_way: 'online-order-badge--on-the-way',
  delivered: 'online-order-badge--delivered',
  cancelled: 'online-order-badge--cancelled',
};

const STATUS_CARD_CLASS: Record<OnlineOrderStatus, string> = {
  placed: 'online-order-card--placed',
  accepted: 'online-order-card--accepted',
  preparing: 'online-order-card--preparing',
  ready: 'online-order-card--waiting-for-rider',
  waiting_for_rider: 'online-order-card--waiting-for-rider',
  on_the_way: 'online-order-card--on-the-way',
  delivered: 'online-order-card--delivered',
  cancelled: 'online-order-card--cancelled',
};

interface OrderStatusBadgeProps {
  status: OnlineOrderStatus;
  className?: string;
}

export function getOrderStatusCardClass(status: OnlineOrderStatus): string {
  return STATUS_CARD_CLASS[status] ?? 'online-order-card--placed';
}

export default function OrderStatusBadge({ status, className = '' }: OrderStatusBadgeProps) {
  const badgeClass = STATUS_BADGE_CLASS[status] ?? 'online-order-badge--placed';
  const label = POS_ORDER_STATUS_LABELS[status] ?? status;

  return (
    <span className={`online-order-badge ${badgeClass} ${className}`.trim()}>
      {label}
    </span>
  );
}
